import React from "react";
import map from "lodash/map";
import get from "lodash/get";
import filter from "lodash/filter";
import { connect } from "react-redux";
import { Alert, Layout, Table, Button, Modal, Breadcrumb, Icon } from "antd";

import classes from "./SpecimenSamplesSettings.css";

import isAuthenticated from "../../utils/isAuthenticated";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import SpecimenSamplesSettingsForm from "./SpecimenSamplesSettingsForm";
import { getSpecimenSamplesSettingsList } from "../../api/requests";

const { Content } = Layout;

class SpecimenSamplesSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      specimenSettingsList: [],
      errorMessage: "",
      responseMessage: "",
      modalVisible: false,
      modalMilestoneVisible: false,
      editSpecimen: null,
      editMilestone: null,
      isLoading: false,
    };
  }

  async componentDidMount() {
    this.getSpecimenSettingsList();
  }

  getSpecimenSettingsList = async () => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getSpecimenSamplesSettingsList();

      this.setState({ specimenSettingsList: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({ errorMessage: get(e, "response.data.error", this.props.i18n.t("Error")) });
    }

    this.setState({ isLoading: false });
  };

  render() {
    const {
      specimenSettingsList,
      errorMessage,
      responseMessage,
      isLoading,
    } = this.state;

    let columns = [
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t(
          "NamespaceSpecimenSample:Specimen Sample"
        ),
        render: (val, record) => (
          <div>
            <span className={classes.textMuted}>#{record.id}</span>{" "}
            <b>{record.name}</b> &nbsp;{" "}
          </div>
        ),
      },
      {
        dataIndex: "event",
        key: "event",
        title: this.props.i18n.t("NamespaceSpecimenSample:Event"),
        render: (val) => <div>{val.name}</div>,
      },
      {
        dataIndex: "collection_form_schemas",
        key: "collection_form_schemas",
        title: this.props.i18n.t(
          "NamespaceSpecimenSample:Collection form schemas"
        ),
        render: (val) => (
          <div>
            {map(val, (item) => (
              <div>{get(item, "form.name")}</div>
            ))}
          </div>
        ),
      },
      {
        dataIndex: "result_form_schemas",
        key: "result_form_schemas",
        title: this.props.i18n.t(
          "NamespaceSpecimenSample:Result form schemas"
        ),
        render: (val) => (
          <div>
            {map(val, (item) => (
              <div>{get(item, "form.name")}</div>
            ))}
          </div>
        ),
      },
      {
        dataIndex: "actions",
        key: "actions",
        width: 100,
        render: (val, record) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Icon
              type="edit"
              theme="filled"
              className={classes.actionIcon}
              onClick={() => {
                this.setState({
                  modalVisible: true,
                  editSpecimen: record,
                });
              }}
            />
          </div>
        ),
      },
    ];

    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t(
                "NamespaceSpecimenSample:Specimen Sample Settings"
              )}
            </h3>
            <Breadcrumb>
              <Breadcrumb.Item href="/admin/settings">
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {this.props.i18n.t(
                  "NamespaceSpecimenSample:Specimen Sample Settings"
                )}
              </Breadcrumb.Item>
            </Breadcrumb>
            <br />

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}

            <div>
              <Button
                type="primary"
                onClick={() => this.setState({ modalVisible: true })}
                loading={isLoading}
                disabled={isLoading}
              >
                {this.props.i18n.t(
                  "NamespaceSpecimenSample:Add setting"
                )}
              </Button>
              <br />
              <br />
            </div>

            <Table
              columns={columns}
              dataSource={filter(
                specimenSettingsList,
                (specimen) => !specimen.is_predefined
              ).sort((a, b) => a.order_index - b.order_index)}
              loading={isLoading}
              pagination={false}
              rowKey="id"
            />

            <br />

            <Modal
              visible={this.state.modalVisible}
              onCancel={() =>
                this.setState({
                  modalVisible: false,
                  editSpecimen: null,
                })
              }
              footer={null}
            >
              {this.state.modalVisible && (
                <SpecimenSamplesSettingsForm
                  {...this.state.editSpecimen}
                  onSubmit={() =>
                    this.setState(
                      { modalVisible: false, editSpecimen: null },
                      this.getSpecimenSettingsList
                    )
                  }
                  onCancel={() =>
                    this.setState({
                      modalVisible: false,
                      editSpecimen: null,
                    })
                  }
                />
              )}
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SpecimenSamplesSettings))
);



// WEBPACK FOOTER //
// ./src/containers/SpecimenSamplesSettings/SpecimenSamplesSettings.js